/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { cached } from '@glimmer/tracking';
import UiBookingMessagesMessageBaseComponent from 'uplisting-frontend/components/ui/booking/messages/message/-base';

export default class UiBookingMessagesMessageInboundComponent extends UiBookingMessagesMessageBaseComponent {
  @cached
  get notificationOverrideMessage(): string | undefined {
    const baseKey =
      'action_bookings_messages.messages.subscription_notification_mappings.inbound';

    if (this.intl.exists(`${baseKey}.${this.message.context}`)) {
      return this.intl.t(`${baseKey}.${this.message.context}`);
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'ui/booking/messages/message/inbound': typeof UiBookingMessagesMessageInboundComponent;
    'Ui::Booking::Messages::Message::Inbound': typeof UiBookingMessagesMessageInboundComponent;
  }
}
